<template>
  <FashionTile
    :fashion="post"
    :fashionImage="fashionImage"
    :settings="settings"
    :popupSettings="popupSettings"
    :hasPrevPost="hasPrevPost"
    :hasNextPost="hasNextPost"
    :popupText="popupText"
    @changePostRequest="
      (direction) => (direction > 0 ? popupNext() : popupPrev())
    "
    :titleMode="popupSettings?.header?.titleMode || 'default'"
  >
    <template v-slot:imageArea>
      <span
        v-if="settings.isShowDescriptionAbovePreview && description"
        class="frisbuy-fashion-list-item__description"
      >
        {{ description }}
      </span>

      <div class="frisbuy-popup-media">
        <div
          v-if="!isCensored && false"
          :class="{
            [`frisbuy-provider-${post.frisbuyPost.providerType}`]: !isCensored,
          }"
        ></div>

        <Popupimage
          v-if="
            !isPlaying ||
            !mediaIsVideo ||
            (typeof popupVideoPositionStyles !== 'undefined' &&
              Object.keys(popupVideoPositionStyles).length > 0)
          "
          :style="{
            visibility: !isPlaying || !mediaIsVideo ? 'visible' : 'hidden',
          }"
          :media="currentMedia"
          :post="post"
          :settings="settings"
          ref="postImage"
        />

        <div
          class="frisbuy-media-play"
          v-if="currentMedia.videoUrl && !isPlaying"
          @click="isPlaying = true"
        >
          <img :src="`${envDomain}/images/widget/play.svg`" />
        </div>

        <div
          v-if="currentMedia.videoUrl"
          :class="{ 'frisbuy-video-wrapper': isPlaying }"
          :style="popupVideoPositionStyles"
        >
          <video
            v-show="isPlaying"
            :controls="isPlaying"
            loop="true"
            controlsList="nodownload"
            :autoplay="popupSettings.autoplayVideo"
            @loadeddata="videoLoaded"
            ref="video"
            @pause="pauseVideo"
            playsinline
          >
            <source @error="errorVideoHandler" type="video/mp4" />
          </video>
        </div>

        <div class="frisbuy-gallery-navigation" v-if="isMultiPosts && false">
          <div
            class="frisbuy-navigation-button"
            v-if="mediaIndex"
            @click="navigate(mediaIndex - 1)"
          >
            <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
              <polyline
                stroke="currentColor"
                fill="none"
                points="16,24 8,16 16,8"
              />
            </svg>
          </div>
          <span></span>
          <div
            class="frisbuy-navigation-button"
            v-if="mediaIndex !== post.media.length - 1"
            @click="navigate(mediaIndex + 1)"
          >
            <svg version="1.1" viewBox="0 0 24 32" xml:space="preserve">
              <polyline
                stroke="currentColor"
                fill="none"
                points="8,8 16,16 8,24"
              />
            </svg>
          </div>
        </div>

        <div class="frisbuy-gallery-pagination" v-if="isMultiPosts && false">
          <div
            v-for="(mediaItem, index) in post.media"
            :key="index"
            :class="{
              'frisbuy-gallery-page': true,
              active: index == mediaIndex,
              'frisbuy-video-play': isPlaying,
            }"
            @click="navigate(index)"
          ></div>
        </div>
      </div>
    </template>
  </FashionTile>
</template>

<style scoped lang="scss">
.frisbuy-fashion-list-item__description {
  position: absolute;

  top: -24px;
  left: 0;
  width: 100%;

  text-align: center;

  overflow-wrap: break-word;
  overflow: hidden;

  color: #2e353b;

  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 400;

  padding-bottom: 4px;
}

.frisbuy-video-wrapper {
  padding-bottom: 100%;
}
</style>

<script>
// Components
import Popupimage from "../../ProductPopup/PopupImage/PopupImage.vue";
import FashionTile from "../../components/FashionTile.vue";
import defaultShopTheLookProductPopup from "../../ProductPopup/ProductPopup.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";

export default {
  extends: defaultShopTheLookProductPopup,

  components: {
    FashionTile,
    Popupimage,
  },

  props: {
    popupText: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.unlockWindowScroll();
  },

  computed: {
    description() {
      return this.post.frisbuyPost.text;
    },
  },

  methods: {
    errorVideoHandler(e) {
      MediaCatcher(e, 2, widgetTypes.SHOP_THE_LOOK);
    },
  },
};
</script>
